import * as t from 'io-ts';

import {RActivityType} from './activityModel';
import {makeApiType} from './apiTypes';
import {parseTeammate, RTeammate} from './teammateModel';

/*
 * Runtime type.
 */

export const RLegacyNotificationDirty = t.readonly(
  t.type({
    id: t.Integer,
    type: RActivityType,
    isUnread: t.boolean,
    fromTeammate: t.union([RTeammate, t.undefined]),
    fromRuleName: t.union([t.undefined, t.string]),
    link: t.string,
    p2FiltersLink: t.string,
    summary: t.string,
    url: t.string,
    bumpedAt: t.Integer,
  }),
);

export const RLegacyNotificationPageDirty = t.readonly(
  t.type({
    limit: t.Integer,
    notifications: t.readonlyArray(RLegacyNotificationDirty),
  }),
);

/*
 * Types.
 */

export interface LegacyNotificationModel extends t.TypeOf<typeof RLegacyNotificationDirty> {}
export const RLegacyNotification = t.clean<LegacyNotificationModel>(RLegacyNotificationDirty as any);

export interface LegacyNotificationPageModel extends t.TypeOf<typeof RLegacyNotificationPageDirty> {}
export const RLegacyNotificationPage = t.clean<LegacyNotificationPageModel>(
  RLegacyNotificationPageDirty as any,
);

/*
 * IO methods.
 */

export function parseLegacyNotification(src: any): LegacyNotificationModel {
  return {
    id: src.id,
    type: src.type,
    isUnread: src.unseen,
    fromTeammate: src.from ? parseTeammate(src.from) : undefined,
    fromRuleName: src.rule_name || undefined,
    link: src.new_link,
    p2FiltersLink: src.link,
    summary: src.summary,
    url: src.url,
    bumpedAt: src.bumped_at,
  };
}

export function parseLegacyNotificationPage(src: any): LegacyNotificationPageModel {
  return {
    limit: src.limit,
    notifications: src.notifications && src.notifications.map(parseLegacyNotification),
  };
}

/*
 * API types.
 */

export const ApiLegacyNotification = makeApiType(
  'legacyNotification',
  RLegacyNotification,
  parseLegacyNotification,
);
export const ApiLegacyNotificationPage = makeApiType(
  'legacyNotificationPage',
  RLegacyNotificationPage,
  parseLegacyNotificationPage,
);
